import { defineMessages, FormattedMessage } from "react-intl";

interface SectionProps {
  id?: string | undefined;
  title?: React.ReactNode;
  children: React.ReactNode;
}

export function ActivityOverviewSection({ id, title, children }: SectionProps) {
  return (
    <div id={id} className="scroll-mt-16">
      {title && (
        <p className="text-grey-900 text-2xl font-semibold leading-8 mb-4">
          {title}
        </p>
      )}
      {children}
    </div>
  );
}

const emptyMessages = defineMessages({
  about: { defaultMessage: "No overview is available yet." },
  description: { defaultMessage: "No description is available yet." },
  timeline: { defaultMessage: "No timeline is available yet." },
  purpose: { defaultMessage: "No purpose is available yet." },
  audience: { defaultMessage: "No participant information is available yet." },
  prizes: { defaultMessage: "No prizes have been announced yet." },
  "getting started": {
    defaultMessage: "No start instructions are available yet.",
  },
});

export function ActivityOverviewEmptySection({
  field,
}: {
  field: keyof typeof emptyMessages;
}) {
  return (
    <p className="text-grey-400 text-sm italic">
      <FormattedMessage {...emptyMessages[field]} />
    </p>
  );
}
